import { Skeleton } from 'antd';
import { SkeletonRegion } from '../../../shared/components/SkeletonRegion';
import type { EligibilityState } from '../hooks/use-blocked-candidates';
import { blockedRows, filterBlockedRows } from '../policies/picker-candidates.policy';
import type { AssignmentSuggestion } from '@chukua/common';
import { BlockedRow } from './BlockedRow';
import { PickerSection } from './PickerSection';

interface BlockedSectionProps {
  eligibility: EligibilityState;
  rankedOnPage: AssignmentSuggestion[];
  q: string | undefined;
}

/** Why the rest of the fleet is not on offer. Its own loading and error states: the crews above do not wait for it. */
export function BlockedSection({ eligibility, rankedOnPage, q }: BlockedSectionProps) {
  if (eligibility.status === 'loading') {
    return (
      <SkeletonRegion label="Loading blocked candidates">
        <Skeleton active paragraph={{ rows: 2 }} title={false} />
      </SkeletonRegion>
    );
  }
  if (eligibility.status === 'error') {
    return <p className="text-sm text-muted">Couldn't load the blocked trucks, trailers and drivers. Reload the page to try again.</p>;
  }

  const rows = filterBlockedRows(blockedRows(eligibility.response, rankedOnPage), q);
  if (rows.length === 0) return null;
  return (
    <PickerSection title="Blocked" count={rows.length}>
      {rows.map((row) => (
        <BlockedRow key={row.key} row={row} />
      ))}
    </PickerSection>
  );
}
